var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2757_26885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77539 0.0996094V1.84961H8.02539V3.40039H7.12012L7.10645 3.4834C6.8679 4.92619 6.23849 6.22287 5.34082 7.24121L5.25684 7.33691L5.36914 7.39551C6.03203 7.74197 6.7717 7.94717 7.55273 7.97266L7.62891 7.97461L7.65137 7.90137L8.42188 5.34961H10.2656L12.8457 13.9004H11.3467L10.8398 12.2207L10.8184 12.1504H7.86914L7.84766 12.2207L7.34082 13.9004H5.8418L7.13379 9.61816L7.16797 9.50293L7.04785 9.49023C5.97998 9.37763 4.98405 8.99811 4.11816 8.41504L4.0625 8.37793L4.00684 8.41504C2.96212 9.11847 1.72801 9.52539 0.40625 9.52539H0.0996094V7.97461H0.40625C1.24856 7.97461 2.0461 7.76646 2.75586 7.39551L2.86816 7.33691L2.78418 7.24121C2.29511 6.68639 1.88721 6.04822 1.57715 5.34961H3.21289C3.43659 5.71761 3.69652 6.05776 3.99023 6.36133L4.0625 6.43555L4.13477 6.36133C4.86874 5.60274 5.40206 4.62238 5.64355 3.52148L5.6709 3.40039H0.0996094V1.84961H3.34961V0.0996094H4.77539ZM9.24805 7.58105L8.37598 10.4707L8.33691 10.5996H10.3506L10.3115 10.4707L9.43945 7.58105L9.34375 7.26367L9.24805 7.58105Z",
    fill: "currentFill",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2757_26885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/LanguageIcon.84d47615918a3ff59dd72d3ef102c596.svg";
export { ForwardRef as ReactComponent };